import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import App from './App.vue';

// Vant 组件
import {
  Button,
  Cell,
  CellGroup,
  DatePicker,
  Dialog,
  Empty,
  Field,
  Form,
  Icon,
  List,
  Loading,
  NavBar,
  Notify,
  Picker,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Search,
  Skeleton,
  Switch,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  Uploader,
  Image as VanImage,
  Badge,
} from 'vant';
// Tailwind CSS 样式
import './style/style.css';
// Vant 样式
import 'vant/lib/index.css';
// 移动端触摸事件
import '@vant/touch-emulator';

const app = createApp(App);

// 只在开发环境启用 VConsole
if (['teachDev', 'development', 'test'].includes(import.meta.env.MODE)) {
  import('vconsole').then((module) => {
    const VConsole = module.default;
    // eslint-disable-next-line no-new
    new VConsole();
  });
}
// 注册 Vant 组件
app.use(Form);
app.use(Field);
app.use(Button);
app.use(Search);
app.use(Icon);
app.use(PullRefresh);
app.use(List);
app.use(Empty);
app.use(Tabbar);
app.use(TabbarItem);
app.use(NavBar);
app.use(VanImage);
app.use(Rate);
app.use(Tag);
app.use(Uploader);
app.use(CellGroup);
app.use(Cell);
app.use(Toast);
app.use(Dialog);
app.use(Notify);
app.use(Picker);
app.use(DatePicker);
app.use(Popup);
app.use(Tabs);
app.use(Tab);
app.use(Radio);
app.use(RadioGroup);
app.use(Switch);
app.use(Loading);
app.use(Skeleton);
app.use(Badge);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);

app.mount('#app');
